import $ from 'jquery';

function AjaxForm($el){
	this.$el = $el;
	this.$form = $el.find('form');
	this.$result = $el.find('.js-ajax-result');
	this.$button = $el.find('button');
	this.button = {name:"",value:""};
	this.init();
}

AjaxForm.prototype = {
	init: function(){
		this.$button.on('click',$.proxy(this.onClick,this));
		this.$form.on('submit',$.proxy(this.onSubmit,this));
	},

	onClick: function(e){
		var $el = $(e.currentTarget);
		this.button = {
			name: $el.prop('name'),
			value: $el.val()
		}
	},

	onSubmit: function(e){
		e.preventDefault();
		var $form = this.$form;
		var formData = new FormData($form[0]);
		formData.set(this.button.name,this.button.value);

		var xhr = $.ajax({
			url: $form.attr('action'),
			type: 'POST',
			data: formData,
			async: false,
			cache: false,
			contentType: false,
			processData: false
		});

		xhr.done($.proxy(this.appendData,this));
	},

	appendData: function(html){
		var $payload = $(html).find('.js-ajax-payload');

		if($payload.length){
			this.$form.find('.form__error').remove();
			this.$form.find('.invalid').removeClass('invalid');
			this.$result.html($payload);
		}else{
			this.$form.off('submit').submit();
		}
	}
}

var $form = $('.js-ajax-form');

$(document).ready(()=>{
	if($form.length && window.FormData){
		$form.each(init);
	}
});

function init(){
	new AjaxForm($(this));
}
